<app-modal style="height: 100%">
  <ng-container modal-header>
    <ion-label slot="start">Add past activity</ion-label>
  </ng-container>
  <ng-container modal-body>
    <form #form="ngForm" (ngSubmit)="save(url)">
      <ion-item lines="none">
        <div class="info">
          Enter an id of any activity from strava and Runnergram will import it
          to your list of activities. (unfortunately you need to access strava
          from desktop to get the activity id)
        </div>
      </ion-item>
      <ion-item>
        <ion-label>Link</ion-label>
        <ion-input
          type="text"
          [(ngModel)]="url"
          name="url"
          placeholder="Enter the activity id"
          required
        ></ion-input>
      </ion-item>
    </form>
  </ng-container>
  <ng-container modal-footer>
    <ion-button slot="start" [disabled]="!form.valid" (click)="save(url)">
      Import <ion-icon name="save"></ion-icon>
    </ion-button>
    <ion-button color="dark" slot="end" (click)="save(null)">
      <ion-icon name="close-outline"></ion-icon>
    </ion-button>
  </ng-container>
</app-modal>
